var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 187,
    viewBox: "0 0 212 187",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.112 187H47.8253C47.0086 187 46.3457 186.337 46.3457 185.518V184.202H165.591V185.518C165.59 186.336 164.929 187 164.112 187Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.64 141.831H81.4219V158.704C97.6544 154.999 114.129 151.925 130.64 149.073V141.831Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 158.704V176.173H130.64V149.073C114.129 151.926 97.6544 154.998 81.4219 158.704Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.955 185.003H47.1082C46.3115 185.003 46.1318 183.882 46.8885 183.632L81.4223 172.247H130.64L165.174 183.632C165.931 183.882 165.752 185.003 164.955 185.003Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.057 172.248H129.473",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 172.248H120.516",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 158.703L118.47 151.223",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.639 141.831V172.248",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4043 185.003H164.156",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 143.868V169.663",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.652 145.621H9.3484C4.73791 145.621 1 141.877 1 137.258V9.363C1 4.74445 4.73791 1 9.3484 1H202.652C207.262 1 211 4.74445 211 9.363V137.259C211 141.877 207.262 145.621 202.652 145.621Z",
    fill: "white",
    stroke: "#141414"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211 31.7148V137.259C211 141.877 207.262 145.622 202.651 145.622H110.174",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 118.367V9.363C1 4.74445 4.73791 1 9.3484 1H202.652",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.237 53.4619C141.512 53.4619 136.252 55.4361 132.084 58.7345C132.085 58.6535 132.087 58.5735 132.087 58.4935C132.087 44.0608 120.407 32.3604 105.999 32.3604C91.5915 32.3604 79.9115 44.0608 79.9115 58.4935C79.9115 58.5745 79.9135 58.6545 79.9145 58.7345C75.7463 55.4361 70.4849 53.4619 64.7612 53.4619C51.2452 53.4619 40.2891 64.4372 40.2891 77.9769C40.2891 91.5165 51.2452 102.492 64.7612 102.492C65.0787 102.492 65.3942 102.48 65.7087 102.468C66.0232 102.48 66.3386 102.492 66.6561 102.492H145.712C145.968 102.492 146.221 102.481 146.475 102.473C146.729 102.481 146.982 102.492 147.238 102.492C160.754 102.492 171.71 91.5165 171.71 77.9769C171.71 64.4372 160.753 53.4619 147.237 53.4619Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.237 53.4619C141.512 53.4619 136.252 55.4361 132.084 58.7345C132.085 58.6535 132.087 58.5735 132.087 58.4935C132.087 44.0608 120.407 32.3604 105.999 32.3604C91.5915 32.3604 79.9115 44.0608 79.9115 58.4935C79.9115 58.5745 79.9135 58.6545 79.9145 58.7345C75.7463 55.4361 70.4849 53.4619 64.7612 53.4619C51.2452 53.4619 40.2891 64.4372 40.2891 77.9769C40.2891 91.5165 51.2452 102.492 64.7612 102.492C65.0787 102.492 65.3942 102.48 65.7087 102.468C66.0232 102.48 66.3386 102.492 66.6561 102.492",
    stroke: "#141414",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.181 116.3C127.614 111.23 133.589 97.0223 128.527 84.5677C123.465 72.1131 109.282 66.1274 96.8496 71.1983C84.4167 76.2691 78.4415 90.4763 83.5035 102.931C88.5655 115.386 102.748 121.371 115.181 116.3Z",
    fill: "#8A8A8A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.36 102.809L107.321 93.7538L116.36 84.6997C116.723 84.3357 116.723 83.7396 116.36 83.3756C115.997 83.0115 115.402 83.0115 115.038 83.3756L106 92.4297L96.9616 83.3756C96.5982 83.0115 96.0032 83.0115 95.6397 83.3756C95.2763 83.7396 95.2763 84.3357 95.6397 84.6997L104.678 93.7538L95.6397 102.809C95.2763 103.173 95.2763 103.769 95.6397 104.133C96.0032 104.497 96.5982 104.497 96.9616 104.133L106.001 95.079L115.039 104.133C115.403 104.497 115.998 104.497 116.361 104.133C116.723 103.769 116.723 103.173 116.36 102.809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.4546c222a656d07abefbf807b7cfce29.svg";
export { ForwardRef as ReactComponent };